import React, { useState, useEffect } from "react";
import "./index.scss";
import { Button, Space, Typography, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getPacksQuery } from "@dataLayer/pack";
import { useRegisterPack, getRemainTurnQuery } from "@dataLayer/user";
import BitelModal, { ModalConfirm } from "@components/Modal";
import OtpModal from "@components/Modal/OtpModal";
import { useRequestOtpPackage } from "dataLayer/user";

//todo
import { PATHS } from '@config/constants';
import { useHistory } from 'react-router-dom';
import { getUserQuery } from '@dataLayer/user';
import AccountPackageHistory from '../AccountPackageHistory/AccountPackageHistory';
import PackSuccess from "@pages/Events/NewYearAndChristmas_2024/Components/animtion/PackSuccess";
import { useLocation } from 'react-router-dom';
import PopupCompleteMission from "@pages/Events/MiniGame/components/PopupFooter/PopupCompleteMission";

const { TabPane } = Tabs;



export const CHANCE_NAME = {
  1: "CHANCE",
  2: "CHANCE2",
  5: "CHANCE5",
  10: "CHANCE10",
};

export const PACK_NAME = {
  1: "Diaria",
  7: "Semanal",
  30: "Mensual",
};

export const PACK_UNIT = {
  1: "día",
  7: "semana",
  30: "mes",
};

export const PACKAGE_CYCLE = {
  daily: "diario",
  weekly: "semanal",
  monthly: "mensual",
};

export const PACK_UNIT_MODAL = {
  1: "diario",
  7: "semanal",
  30: "mensual",
};

const { Title, Paragraph } = Typography;
const AccountSubscription = () => {
  const location = useLocation();
  const { data: user } = useQuery(getUserQuery());
  const history = useHistory();  

  const DEFAULT_TAB = "tab_1";
  const { t } = useTranslation();

  // Nếu có ?retail trên URL thì active tab_2
  const params = new URLSearchParams(location.search);
  const hasRetail = params.has('retail');

  const [currentTab, setCurrentTab] = useState(hasRetail ? "tab_2" : DEFAULT_TAB);

  // Sync nếu URL thay đổi
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('retail')) {
      setCurrentTab("tab_2");
    }
  }, [location.search]);

  const callback = (key) => {
    setCurrentTab(key);
  };


  const { data: packs } = useQuery(getPacksQuery());
  const { data: currentPack } = useQuery(getRemainTurnQuery());
  const {
    mutate: mutateRegisterPack,
    data: dataRegisterPack,
    error: errorRegisterPack,
    isLoading,
  } = useRegisterPack();
  const {
    mutate: mutateGetOTP,
    data: dataGetOtp,
    error: errorGetOtp,
  } = useRequestOtpPackage();

  const [displayConfirm, setDisplayConfirm] = useState(false);
  const [selectedPack, setSelectedPack] = useState();
  const [isCancelAction, setIsCancelAction] = useState(false);
  const [displayOtp, setDisplayOtp] = useState(false);
  const [selectedPackPrice, setSelectedPackPrice] = useState();

  const [pendingReward, setPendingReward] = useState(null);
  const [showMinigamePopup, setShowMinigamePopup] = useState(false);
  const [minigameRewardData, setMinigameRewardData] = useState(null);

  useEffect(() => {
    
    if (+dataRegisterPack?.errorCode === 0) {
      if (
        dataRegisterPack?.reelAddNormal > 0 ||
        dataRegisterPack?.reelAddSuper > 0
      ) {
        setPendingReward(dataRegisterPack);
      }
    }
  }, [dataRegisterPack]);

  const handleCloseRegisterModal = () => {
    if (pendingReward) {
      setMinigameRewardData(pendingReward);

      setTimeout(() => {
        setShowMinigamePopup(true);
      }, 200);

      setPendingReward(null);
    }
  };  

  const handleClickRegister = (packId, packPrice) => () => {
    setDisplayConfirm(true);
    setSelectedPack(packId);
    setSelectedPackPrice(packPrice);
    if (packId.startsWith("SUBASTA")) {
      setIsCancelAction(
        packId ===
          currentPack?.find((pack) => pack?.pack_id === packId)?.pack_id
      );
    } else {
      setIsCancelAction(false);
    }
  };

  const handleOk = () => {
    setDisplayConfirm(false);
    if (!selectedPack) {
      return;
    }
    if (selectedPack.startsWith("SUBASTA")) {
      mutateRegisterPack({ packId: selectedPack, isRegister: !isCancelAction });
    } else {
      mutateGetOTP({ selectedPackPrice, selectedPack });
      setDisplayOtp(true);
    }
  };

  const closeConfirm = () => setDisplayConfirm(false);

  const handleCancelOtp = () => {
    setDisplayOtp(false);
  };

  return (
    <>
      <Title level={2} className="account-page-title">
        {t("account.subscription_page.title")}
      </Title>
      <Tabs
        className="chance-page-tabs"
        type="card"
        size="large"
        activeKey={currentTab}
        onTabClick={callback}
      >
        <TabPane tab={t("bid.package")} key="tab_1">
          <div className="account-subscription">
            <div className="account-subscription-list">
              {packs?.map((pack, index) => {
                return (
                  <>
                    {pack?.cycle != null ? (
                      <div key={index} className="account-subscription-item">
                        <Space direction="vertical" size={[10, 10]}>
                          <Title
                            level={5}
                            className="account-subscription-item-sub-title"
                          >
                            {t("account.subscription_page.type_pack").replace(
                              "_TYPE_",
                              PACK_NAME[pack?.cycle] || pack?.cycle
                            )}
                          </Title>
                          <Title
                            level={4}
                            className="account-subscription-item-title"
                          >
                            {t(
                              "account.subscription_page.bid_per_pack"
                            ).replace("_TURN_", pack?.max_turn)}{" "}
                            <span className="note-item">
                              {t(
                                "account.subscription_page.time_per_pack"
                              ).replace(
                                "_TIME_",
                                PACK_UNIT[pack?.cycle] || "day"
                              )}
                            </span>
                          </Title>
                          <Paragraph
                            className="account-subscription-item-detail"
                            ellipsis={{
                              rows: 2,
                              expandable: true,
                              symbol: "more",
                            }}
                          ></Paragraph>
                          <Button
                            disabled={isLoading}
                            loading={
                              selectedPack === pack?.pack_id && isLoading
                            }
                            className="account-subscription-item-button"
                            data-cancel={
                              currentPack?.find(
                                (item) => item?.pack_id === pack?.pack_id
                              )?.pack_id === pack?.pack_id
                            }
                            onClick={handleClickRegister(pack?.pack_id)}
                          >
                            <span>
                              {t("currency_sign")} {pack?.price / 10000}
                            </span>
                          </Button>
                        </Space>
                      </div>
                    ) : null}
                  </>
                );
              })}
            </div>
          </div>
        </TabPane>
        <TabPane tab={t("bid.buy_more_bids")} key="tab_2">
          <div className="account-subscription">
            <div className="account-subscription-list account-chance-list">
              {packs?.map((pack, index) => {
                return (
                  <>
                    {pack?.cycle == null ? (
                      <div
                        key={index}
                        className="account-subscription-item account-chance-list-item"
                      >
                        <Space direction="vertical" size={[10, 10]}>
                          <Title
                            level={5}
                            className="account-subscription-item-sub-title"
                          >
                            {t("account.subscription_page.type_pack").replace(
                              "_TYPE_",
                              CHANCE_NAME[pack?.max_turn] || pack?.pack_id
                            )}
                          </Title>
                          <Title
                            level={4}
                            className="account-subscription-item-title"
                          >
                            {pack?.max_turn === 1
                              ? t("account.subscription_page.one_bid").replace(
                                  "_TURN_",
                                  pack?.max_turn
                                )
                              : t(
                                  "account.subscription_page.bid_per_pack"
                                ).replace("_TURN_", pack?.max_turn)}
                          </Title>
                          {/* <Paragraph className="valid_in_day">{ t("account.subscription_page.time_expire") }</Paragraph> */}
                          <Paragraph
                            className="account-subscription-item-detail"
                            ellipsis={{
                              rows: 2,
                              expandable: true,
                              symbol: "more",
                            }}
                          ></Paragraph>
                          <Button
                            disabled={isLoading}
                            loading={
                              selectedPack === pack?.pack_id && isLoading
                            }
                            className="account-subscription-item-button"
                            onClick={handleClickRegister(
                              pack?.pack_id,
                              pack?.price
                            )}
                          >
                            <span>
                              {t("currency_sign")} {pack?.price / 10000}
                            </span>
                          </Button>
                        </Space>
                      </div>
                    ) : null}
                  </>
                );
              })}
            </div>
          </div>
        </TabPane>
        {/* <TabPane tab={t("bid.purchase_history")} key="tab_3">
          <AccountPackageHistory user={user} />
        </TabPane> */}
      </Tabs>
      <PackSuccess
        isSuccessSubPack={+dataRegisterPack?.errorCode === 0}
        selectedPack={selectedPack}
        isShow={!isCancelAction}
      />

      <BitelModal
        defaultMsg={t("account.subscription")}
        data={dataRegisterPack}
        error={errorRegisterPack}
        titleSuccess={t("success")}
        btnSuccess={t("modal.thank")}
        isCancelAction={isCancelAction}
        onClose={handleCloseRegisterModal}
      />
      <PopupCompleteMission
        visible={showMinigamePopup}
        setVisible={setShowMinigamePopup}
        type="normal_coin"
        data={minigameRewardData}
      />      
      <BitelModal
        defaultMsg={t("account.subscription")}
        error={errorGetOtp}
        titleSuccess={t("success")}
        btnSuccess={t("modal.thank")}
      />
      <ModalConfirm
        visible={displayConfirm}
        message={t("account.bid_history_page.confirm_msg")}
        title={isCancelAction ? t("cancel_subscription") : t("confirm")}
        handleOk={handleOk}
        handleCancel={closeConfirm}
        isCancelAction={isCancelAction}
      />
      <OtpModal
        visible={displayOtp}
        handleCancelOtp={handleCancelOtp}
        dataGetOtp={dataGetOtp}
        selectedPackPrice={selectedPackPrice}
        selectedPack={selectedPack}
        isShow={!isCancelAction}
      />
    </>
  );
};

export default AccountSubscription;
